<div class="quick-access-wrapper">
  <h1 class="quick-access-heading">{{'quick-access.Social' | translate}}</h1>
  <p class="quick-access-para">{{'quick-access.Lotto' | translate}}</p>
  <ion-img class="home-gif" src="assets/gif/add-home-v3.gif"></ion-img>
  <p (click)="back()" class="back-arrow"><span class="back-icon">← </span> {{'quick-access.Back' | translate}}</p>
</div>